export default __webpack_public_path__ + "static/media/arbeidsvitaminen.30bc2c1c.jpg";